module.exports = __webpack_public_path__ + "fonts/iconfont.53f4952.woff";